/** Ayuda contextual — resúmenes alineados con docs/usuario/. */

const LEADS_HELP = {
  moduleId: "leads",
  introSectionId: "modulo-intro",
  defaultSectionId: "modulo-intro",
  docId: "usuario/crm/leads-y-clientes.md",
  sections: {
    "modulo-intro": {
      id: "modulo-intro",
      title: "Consultas y cotizaciones",
      bullets: [
        "Bandeja de formularios del sitio y cotizaciones del carrito.",
        "Vendedor: solo ve leads asignados a su cuenta.",
        "Actualice estado y notas antes de salir del detalle.",
      ],
      docId: "usuario/crm/leads-y-clientes.md",
    },
    filtros: {
      id: "filtros",
      title: "Filtros y cliente",
      bullets: [
        "Filtre por tipo de consulta desde el selector superior.",
        "Desde Clientes puede abrir leads con ?cliente= en la URL.",
        "Admin y editor ven el listado completo.",
      ],
      docId: "usuario/crm/leads-y-clientes.md",
    },
  },
};

const USERS_HELP = {
  moduleId: "users",
  introSectionId: "modulo-intro",
  defaultSectionId: "modulo-intro",
  docId: "usuario/gestion/usuarios-y-roles.md",
  sections: {
    "modulo-intro": {
      id: "modulo-intro",
      title: "Usuarios CMS",
      bullets: [
        "Crear usuario requiere OTP vigente y rol con permiso de gestión.",
        "El rol define la plantilla de módulos; puede ajustar casillas por persona.",
        "Admin no gestiona cuentas de superadministración ocultas.",
      ],
      docId: "usuario/gestion/usuarios-y-roles.md",
    },
  },
};

const REGISTRY = {
  leads: LEADS_HELP,
  users: USERS_HELP,
};

export function getModuleHelpConfig(moduleId) {
  return REGISTRY[moduleId] ?? null;
}

export function getModuleHelpSection(config, sectionId) {
  return config.sections[sectionId] ?? config.sections[config.defaultSectionId];
}
